"use strict";

angular.module('app.factories.rooms', []).// app.factories.rooms-module

factory('f_Rooms', [
    function () {

        var rooms = [];
        var deviceRooms = [];
        var loading = false;
        var roomsWithDevices = false;
        var obj = {


        }
        return obj;
    }]);
